<template>
    <PageContainer>
        <PageHeader>
            {{ $t('dashboard.welcome') }} {{ user.name }}
        </PageHeader>

        <div class="container">
            <div class="row">
                <div class="col-md-4 mt-3 mt-md-0">
                    <DashboardBox
                        :title="`${remaining_quantity}`"
                        :description="$t('dashboard.total_remaining')"
                        :custom-class="['bg-orange-custom', 'border-orange-custom']"
                    />
                </div>
                <div class="col-md-4 mt-3 mt-md-0">
                    <DashboardBox
                        :title="`${total_delivered}`"
                        :description="$t('dashboard.total_delivered')"
                        :custom-class="['bg-black', 'border-black', 'text-white']"
                    />
                </div>
                <div class="col-md-4 mt-3 mt-md-0">
                    <div class="row">
                        <div class="col-lg-6">
                            <DashboardShortcut :title="$t('dashboard.register')" href="issueLogs/delivered" />
                        </div>
                        <div class="col-lg-6">
                            <DashboardShortcut :title="$t('dashboard.scan')" href="/scan/delivered" />
                        </div>
                        <div class="col-lg-6">
                            <DashboardShortcut :title="$t('dashboard.devolution')" href="issueLogs/devolution" />
                        </div>
                        <div class="col-lg-6">
                            <DashboardShortcut :title="$t('navbar.stock')" href="/stock" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PageContainer>
</template>

<script setup lang="ts">
import PageContainer from "@/components/elements/PageContainer.vue";
import PageHeader from "@/components/elements/PageHeader.vue";
import type {UserInterface} from "@/components/helpers/Interfaces.ts";
import DashboardBox from "@/components/elements/DashboardBox.vue";
import DashboardShortcut from "@/components/elements/DashboardShortcut.vue";

const {remaining_quantity, total_delivered} = defineProps<{
    remaining_quantity: Number,
    total_quantity: Number,
    total_delivered: Number,
    user: Pick<UserInterface, 'name'>
}>()
</script>

<style scoped>
</style>
